import { render, staticRenderFns } from "./SectionPagination.vue?vue&type=template&id=3064f36a&scoped=true&"
import script from "./SectionPagination.vue?vue&type=script&lang=ts&"
export * from "./SectionPagination.vue?vue&type=script&lang=ts&"
import style0 from "./SectionPagination.vue?vue&type=style&index=0&id=3064f36a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3064f36a",
  null
  
)

export default component.exports